export const ClientSettingKey = {
  BvffFixedProperties: 'FixedProperties'
};